export const widthOfMobile = 768;
export const widthOfHeaderCollapse = 992;
